import React from 'react';

export const PageHeading = ({children}) => (
  <h1 className="text-center text-md-left">{children}</h1>
);